import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import {
  VoucherListItemResponse,
  VoucherListResponse,
} from '@naus-code/naus-admin-types';
import { useCallback, useState } from 'react';

import { FlatList } from '~/components/FlatList/FlatList';
import { PageHeader } from '~/components/Page/Page.Header';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

import { VoucherListItemComponent } from '../Voucher.ListItem';

interface CreateVoucherListProps {
  voucherList?: VoucherListResponse;
  onPress: (voucherId: string) => void;
}

export const CreateVoucherListNative = ({
  voucherList,
}: {
  voucherList?: VoucherListResponse;
}) => {
  const navigate = useAppNavigation();
  return (
    <CreateVoucherList
      voucherList={voucherList}
      onPress={(itemId) => {
        navigate.navigate('Voucher-Item', {
          id: itemId,
        });
      }}
    />
  );
};

export const CreateVoucherList = (props: CreateVoucherListProps) => {
  const [selectedId, setSelectedId] = useState('');

  const onPressVoucher = (voucherId: string) => {
    setSelectedId(voucherId);
    props.onPress(voucherId);
  };

  const renderItem = useCallback(
    (voucher: VoucherListItemResponse) => {
      return (
        <VoucherListItemComponent
          key={voucher.id}
          voucher={voucher}
          selected={selectedId === voucher.id}
          onPress={() => onPressVoucher(voucher.id)}
        />
      );
    },
    [selectedId],
  );

  return (
    <VStack space="2.5" flex={1}>
      <PageHeader title={translate('voucher.createdVouchers')} />
      <FlatList
        feedback={translate('voucher.emptyVoucherList')}
        data={props.voucherList?.vouchers ?? []}
        isLoading={false}
        showsVerticalScrollIndicator={isWeb}
        simple
        renderItem={renderItem}
      />
    </VStack>
  );
};
